import React from 'react';
import ProviderIndependentVideoEmbed from './embed_types/ProviderIndependentVideoEmbed';
import OtherEmbed from './embed_types/OtherEmbed';

const SubmitEmbed = ({
  onSubmit,
  onUrlInput,
  isVideo,
  canUploadVideo,
  canRecordInLessonEditor,
  dropInId,
  hasZiggeoForAllMedia,
  toggleRecordMenu,
  submitRecording,
  canRecordWithWistia,
  embedId,
}) => {
  if (isVideo) {
    return (
      <ProviderIndependentVideoEmbed
        submitRecording={submitRecording}
        onSubmit={onSubmit}
        onUrlInput={onUrlInput}
        provider={hasZiggeoForAllMedia ? 'ziggeo' : 'hippo_video'}
        elementId={embedId}
      />
    );
  }
  return <OtherEmbed onSubmit={onSubmit} onUrlInput={onUrlInput} />;
};

export default SubmitEmbed;
